/**
 * Replaces adviser variable placeholders in an HTML string with values from adviserDetails.
 *
 * @param {string} html - The HTML string containing adviser variable placeholders (e.g., {{adviser_name}})
 * @param {object} adviserDetails - The adviser details object with fields: full_name, id_number, email, branch_name, address
 * @returns {string} - The HTML string with adviser variables replaced
 */
/**
 * Replace adviser variables in HTML content with actual adviser details.
 * 
 * @param {string} html - HTML content containing adviser variables
 * @param {Object} adviserDetails - Adviser details object
 * @returns {string} HTML content with variables replaced
 */
export function replaceAdviserVariables(html, adviserDetails) {
  if (!html || !adviserDetails) return html;

  const adviserVariableMap = {
    adviser_name: adviserDetails.full_name,
    adviser_address: adviserDetails.address,
    financial_adviser_fullname: adviserDetails.full_name,
    financial_adviser_id_number: adviserDetails.id_number,
    financial_adviser_email: adviserDetails.email,
    financial_adviser_branch: adviserDetails.branch_name,
  };

  let processedHtml = html;
  Object.entries(adviserVariableMap).forEach(([variable, value]) => {
    const regex = new RegExp(`{{\\s*${variable}\\s*}}`, 'g');
    processedHtml = processedHtml.replace(regex, value ?? `[MISSING:${variable}]`);
  });

  return processedHtml;
}